// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"f2df10fdcd9b3bbc5431","293":"2d14aaee9352a160989f","518":"87220b724b069fd77ecc","779":"3d235264bdeaffd6bafc"}[chunkId] + ".js";
};